import { Servidor } from 'model/ufc/Servidor';
import React, { FC } from 'react';
import { H3, H4 } from 'view/component/Tipografia/Texto';
import {BuscaServidoresFormulario} from 'view/section/BuscaServidoresSection/formulario/BuscaServidoresFormulario'
import { ServidoresLista } from './ServidoresLista';


interface BuscaServidoresSectionProps {
  onServidorSelected: (servidor: Servidor) => void;
  onCancelar: () => void;
}

export const BuscaServidoresSection: FC<BuscaServidoresSectionProps> = ({onServidorSelected, onCancelar}) => {
  return <>
    <H3>Busca de servidores</H3>
    <BuscaServidoresFormulario onCancelar={onCancelar} />

    <H4>Resultado</H4>
    <ServidoresLista onServidorSelected={onServidorSelected} />
  </>
}
